import { Button, Modal } from '@orbind/ui'
import { useState } from 'react'
import { useWorkItemDetail } from './api.ts'

/**
 * "Filho de": COMO entrar no pai (SPEC-20261008-2204-filho-de-em-checklist-do-pai,
 * pedido do Cristian: "ao selecionar o item possa escolher para incluir como
 * parte de um checklist do pai ou incluir somente como filho").
 *
 * Mostra os checklists do pai escolhido; "Só como filho" é a primeira opção.
 * Escolher um checklist faz o item virar filho E linha daquele checklist — o
 * mesmo que "Selecionar item existente" de dentro do checklist do pai.
 */
export function ComoIncluirNoPai({
  paiId,
  codigoDoItem,
  incluindo,
  onConfirmar,
  onFechar,
}: {
  paiId: string
  codigoDoItem: string
  incluindo: boolean
  /** `checklistId` nulo = só como filho. */
  onConfirmar: (checklistId: string | null) => void
  onFechar: () => void
}) {
  const pai = useWorkItemDetail(paiId)
  const [escolha, setEscolha] = useState<string | null>(null)
  const checklists = pai.data?.collab.checklists ?? []
  const codigoDoPai = pai.data?.item.code ?? '…'

  const opcao = (id: string | null, titulo: string, detalhe: string, icone: string) => (
    <button
      key={id ?? 'so-filho'}
      type="button"
      role="radio"
      aria-checked={escolha === id}
      className={`wi-excluir__opcao${escolha === id ? ' wi-excluir__opcao--on wi-incluir__opcao--on' : ''}`}
      onClick={() => setEscolha(id)}
    >
      <i className={escolha === id ? 'fas fa-dot-circle' : 'far fa-circle'} aria-hidden />
      <span>
        <strong>
          <i className={icone} aria-hidden style={{ fontSize: 11, marginRight: 6 }} />
          {titulo}
        </strong>
        <small>{detalhe}</small>
      </span>
    </button>
  )

  return (
    <Modal
      open
      onClose={incluindo ? () => {} : onFechar}
      title={`Como ${codigoDoItem} entra em ${codigoDoPai}?`}
      width={500}
      footer={
        <>
          <Button variant="ghost" onClick={onFechar} disabled={incluindo}>
            Cancelar
          </Button>
          <Button variant="primary" loading={incluindo} disabled={pai.isPending} onClick={() => onConfirmar(escolha)}>
            {escolha ? 'Incluir no checklist' : 'Incluir como filho'}
          </Button>
        </>
      }
    >
      <div className="wi-excluir">
        {pai.isPending ? <p className="wi-excluir__texto">Carregando os checklists de {codigoDoPai}…</p> : null}
        {pai.data ? (
          <div className="wi-excluir__escolha" role="radiogroup" aria-label="Como incluir no pai">
            {opcao(null, 'Só como filho', `Fica entre os filhos de ${codigoDoPai}, fora de qualquer checklist.`, 'fas fa-sitemap')}
            {checklists.map((c) =>
              opcao(
                c.id,
                c.name,
                `Vira uma linha deste checklist de ${codigoDoPai} (${c.items.length} ${c.items.length === 1 ? 'linha' : 'linhas'}), e filho dele.`,
                'fas fa-tasks',
              ),
            )}
            {checklists.length === 0 ? (
              <p className="wi-excluir__texto">{codigoDoPai} não tem checklists — o item entra como filho.</p>
            ) : null}
          </div>
        ) : null}
      </div>
    </Modal>
  )
}
